import { useParams } from 'react-router-dom';
import { IndividualOrderRequest } from './ViewIndividualOrderRequest';

export function ViewIndividualOrderRequestWrapper() {
    const { id } = useParams();

    return (
        <IndividualOrderRequest orderRequestId={id} />
    )
}